module.exports = __webpack_public_path__ + "static/media/04.54cd11c0.webp";